// assets/offer-cart-refresh.js
(function () {
  if (window.__OfferRefreshDrawerInstalled) return;
  window.__OfferRefreshDrawerInstalled = true;

  async function safeJson(res) {
    try {
      return await res.json();
    } catch {
      return null;
    }
  }

  async function fetchSections(sectionIds) {
    const url =
      window.location.pathname +
      "?sections=" +
      encodeURIComponent(sectionIds.join(","));

    const res = await fetch(url, { credentials: "same-origin" });
    if (!res.ok) return null;
    return await safeJson(res);
  }

  function getDrawerSectionId() {
    const drawer = document.querySelector("#CartDrawer");
    return drawer?.dataset?.sectionId || drawer?.dataset?.sectionid || null;
  }

  function updateBubble(html) {
    const bubble =
      document.querySelector("#cart-icon-bubble") ||
      document.querySelector("cart-icon-bubble");
    if (!bubble) return false;
    bubble.innerHTML = html;
    return true;
  }

  function replaceInnerHTML(fromSectionHtml, selector) {
    try {
      const tmp = document.createElement("div");
      tmp.innerHTML = fromSectionHtml;

      const fresh = tmp.querySelector(selector);
      const live = document.querySelector(selector);

      if (!fresh || !live) return false;

      live.innerHTML = fresh.innerHTML;

      // ✅ re-init Alpine on the updated subtree only
      if (window.Alpine?.initTree) window.Alpine.initTree(live);

      return true;
    } catch {
      return false;
    }
  }

  // Expose a single safe function you can call from offer-logger
  window.__OfferRefreshDrawer = async function () {
    const sectionId = getDrawerSectionId();

    // if drawer isn't present, just update bubble
    const sections = [];
    if (sectionId) sections.push(sectionId);
    sections.push("cart-icon-bubble");

    const data = await fetchSections(sections);
    if (!data) return false;

    if (data["cart-icon-bubble"]) updateBubble(data["cart-icon-bubble"]);

    if (!sectionId || !data[sectionId]) return true;

    const sectionHtml = data[sectionId];

    // ✅ IMPORTANT: update inner content, DO NOT replace #CartDrawer
    // 1) items
    replaceInnerHTML(sectionHtml, "#CartDrawerForm");

    // 2) shipping block (optional)
    replaceInnerHTML(sectionHtml, "#CartDrawer__ShippingDelivery");

    // 3) totals/summary area if your theme has a stable id (optional)
    // If you have an id for the summary wrapper, add it here.
    // Example:
    // replaceInnerHTML(sectionHtml, "#CartDrawer__Summary");

    return true;
  };
})();